module.exports = () => {

  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
  }

  var mobileBrowser = getMobileOperatingSystem();

  function getLink(string) {
    string = string.replace(/ /g,"+");
    switch (mobileBrowser) {
    	case "iOS":
    		return "https://maps.apple.com/?q=" + string;
    		break;
    	default:
    		return "https://maps.google.com/?q=" + string;
    }
  }

  const addressTags = document.querySelectorAll('[data-address]');

  addressTags.forEach(tag => {
    tag.href = getLink(tag.dataset.address);
  });


}
